module.exports = {template: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.667 6.667a1.333 1.333 0 0 1 0 2.666H9.333v5.334a1.333 1.333 0 0 1-2.666 0V9.333H1.333a1.333 1.333 0 1 1 0-2.666h5.334V1.333a1.333 1.333 0 1 1 2.666 0v5.334h5.334z" fill="#F0532C"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/plus.svg
// module id = 220
// module chunks = 1